export const MODAL_TITLE = 'You’re not signed up yet';
export const NOT_NOW_BUTTON_COPY = 'Not Now';
export const LOGIN_BUTTON_COPY = 'OK';
